<template>
  <div id="character-spell-wrap">
    <div class="character-spell-heading">
      <input 
        type="checkbox" 
        name="have-spell" 
        id="have-spell"
        v-model="spell.have">
      <h5 @click="showSpellBody = !showSpellBody">{{ spell.title }}</h5>
    </div>
    <div 
      class="spell-body"
      ref="spellBody"
      :style="spell.have !== null ? 'margin-left: 1.5em;' : ''"
      v-html="spell.html" 
      v-show="showSpellBody">
    </div>
  </div>
</template>

<script>
export default {
  name: 'CharacterSpell',
  props: ['spell'],
  data() {
    return {
      showSpellBody: false,
      have: null,
      extras: []
    } 
  },
  watch: {
    spell: {
      handler: function(val){
        this.$store.commit('updateCharacterSpell', val);
      },
      deep: true
    }
  }
}
</script>

<style lang="css">
  #character-spell-wrap {
    margin-top: 0.5em;
  }

  .character-spell-heading {
    display: flex;
    margin-left: 1em;
  }
   
  .character-spell-heading > h5 {
    margin-top: 0;
    margin-bottom: 0.2em;
    margin-left: 0;
    border-bottom: 1px solid black;
  }

  .character-spell-heading > #have-spell {
    width: 1em;
    height: 1em;
    background: white;
  }

  #character-spell-wrap > .spell-body > * {
    /* margin-left: 2em; */
    margin-top: 0.5em;
    text-align: left;
    font-size: 14px;
  }

  .spell-property {
    display: flex;
  }

</style>